import { getSlugFromURL } from "."

/**
 * Loads a dynamic extension script from the server.
 *
 * @param {string} componentName - The extension component name/slug.
 * @param {string} [appKey] - Optional app key override. Defaults to sessionStorage app_key.
 * @returns {Promise<void>} Resolves when script loads successfully.
 */
export function loadExtension(componentName, appKey) {
    return new Promise((resolve, reject) => {
        const baseUrl = process.env.REACT_APP_API_URL || ""
        const companyKey = appKey || sessionStorage.getItem("app_key")
        const slug = componentName ? componentName : getSlugFromURL()
        const fileURL = `${baseUrl}static/media-files/asset/${companyKey}/dynamic-action/extensions/${slug}_build.js`

        // remove previous script
        const oldScript = document.querySelector(`script[data-extension="${slug}"]`)
        if (oldScript) oldScript.remove()

        // clean old extension registration
        if (window.ExtensionPages) {
            delete window.ExtensionPages[slug]
        }

        const script = document.createElement("script")
        script.src = `${fileURL}?v=${Date.now()}`
        script.async = true
        script.setAttribute("data-extension", slug)

        script.onload = () => resolve()
        script.onerror = (e) => {
            console.error("Extension script failed:", e)
            reject(new Error("Extension script load failed"))
        }

        document.body.appendChild(script)
    })
}
